import React from 'react';
import classes from './Navbar.css';
// import Logo from '../../Logo/Logo.jsx';
import Hamburger from './Hamburger/Hamburger.jsx';
import NavigationItems from '../NavigationItems/NavigationItems.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHamburger } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const navbar = (props) => {
  return <header className={classes.container}>
    <div className={classes.navbar}>
      <h1>
        <Link to='/build' className={classes.logoLink}><FontAwesomeIcon icon={faHamburger} /> Burger Builder </Link>
      </h1>
      <NavigationItems
        activePage={props.activePage}
        openState={props.openState}
        closeDrawer={props.closeDrawer}
        isAuth={props.isAuth}
      />
      <Hamburger
        toggleDrawer={props.toggleDrawer}
        openState={props.openState}
      />

    </div>
  </header>
};

export default navbar;


// WEBPACK FOOTER //
// ./src/components/Navigation/Navbar/Navbar.jsx